import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const AdminMessagesView = () => import('@/views/admin/MessagesView.vue');
const AdminMessagesIndexView = () => import('@/views/admin/messages/IndexView.vue');
const AdminMessagesSettingsView = () => import('@/views/admin/messages/SettingsView.vue');
const AdminMessagesUsageView = () => import('@/views/admin/messages/UsageView.vue');
const AdminMessagesTestView = () => import('@/views/admin/messages/TestView.vue');

export const NAME_ADMIN_MESSAGES = 'AdminMessages';
export const NAME_ADMIN_MESSAGES_INDEX = 'AdminMessagesIndex';
export const NAME_ADMIN_MESSAGES_SETTINGS = 'AdminMessagesSettings';
export const NAME_ADMIN_MESSAGES_USAGE = 'AdminMessagesUsage';
export const NAME_ADMIN_MESSAGES_TEST = 'AdminMessagesTest';
export const PATH_ADMIN_MESSAGES = 'messages';

const children = [
  { path: '', component: AdminMessagesIndexView, name: NAME_ADMIN_MESSAGES_INDEX, meta: { dataLoaders: ['project_document', 'features'] } },
  { path: 'settings', component: AdminMessagesSettingsView, name: NAME_ADMIN_MESSAGES_SETTINGS, meta: { dataLoaders: ['project_document', 'features'] } },
  { path: 'usage', component: AdminMessagesUsageView, name: NAME_ADMIN_MESSAGES_USAGE, meta: { dataLoaders: ['project_document', 'features'] } },
  { path: 'test', component: AdminMessagesTestView, name: NAME_ADMIN_MESSAGES_TEST, meta: { dataLoaders: ['project_document', 'features'] } },
];

export const route: DiscoveredRouteModule = {
  id: 'admin.messages',
  scope: 'admin',
  moduleKey: 'messages',
  name: NAME_ADMIN_MESSAGES,
  path: PATH_ADMIN_MESSAGES,
  component: AdminMessagesView,
  redirect: { name: NAME_ADMIN_MESSAGES_INDEX },
  meta: { 
    requiresAdmin: true, 
    requiresFeature: 'messages',
    dataLoaders: ['project_document', 'features'] 
  },
  children,
};

